import {
  Component,
  OnInit,
  HostListener,
  Input,
  OnDestroy,
} from "@angular/core";
import {
  CdkDragDrop,
  moveItemInArray,
  transferArrayItem,
} from "@angular/cdk/drag-drop";
import {
  trigger,
  state,
  transition,
  animate,
  style,
  keyframes,
} from "@angular/animations";
import { Subject } from "rxjs";
import { UserManager } from "src/app/Services/UserManager/user-manager";
import { LanguageSwitchService } from "../../Services/LanguageSwitch/language-switch.service";

@Component({
  selector: "app-ani2",
  templateUrl: "./ani2.component.html",
  styleUrls: ["./ani2.component.css", "./svg.scss"],
  animations: [
    trigger("shake", [
      state("void", style({})),
      state("pulsing", style({})),
      transition("void => pulsing", [
        animate(
          "1s",
          keyframes([
            style({ transform: "translate(2px, 1px) rotate(0deg)" }),
            style({ transform: "translate(-1px, -2px) rotate(-1deg" }),
            style({ transform: "translate(-3px, 0px) rotate(1deg)" }),
            style({ transform: "translate(0px, 2px) rotate(0deg)" }),
            style({ transform: "translate(1px, -1px) rotate(1deg)" }),
            style({ transform: "translate(-1px, 2px) rotate(-1deg" }),
            style({ transform: "translate(-3px, 1px) rotate(0deg)" }),
            style({ transform: "translate(2px, 1px) rotate(-1deg)" }),
            style({ transform: "translate(-1px, -1px) rotate(1deg)" }),
            style({ transform: "translate(2px, 2px) rotate(0deg)" }),
            style({ transform: "translate(1px, -2px) rotate(-1deg)" }),
          ])
        ),
      ]),
      transition("* => void", [animate("300ms ease-in-out")]),
    ]),
  ],
})
export class Ani2Component implements OnInit, OnDestroy {
  @Input() mobile: boolean;
  constructor(private um: UserManager, private ls: LanguageSwitchService) {
    this.ls.config.subscribe({
      next: (config) => {
        this.config = config;
        this.wordCloud = config.demoWords;
      },
    });
  }
  profile;
  config;
  leaving = new Subject();
  question = ["1", "2", "3", "4", "5", "6"];
  answersArray = [];
  allCorrect = false;
  wordCloud = [];
  vpid1 = [];
  vpid2 = [];
  vpid3 = [];
  vpid4 = [];

  vpids = ["vpid-1", "vpid-2", "vpid-3", "vpid-4"];
  pulseState = "void";
  ngOnInit(): void {
    this.um
      .getProfileSubject()
      .takeUntil(this.leaving)
      .subscribe((p) => (this.profile = p));
    let options = {
      root: null,
      rootMargin: "100px",
      threshold: 0.25,
    };

    // let observer = new IntersectionObserver(console.log, options);

    // observer.observe
  }

  ngOnDestroy() {
    this.leaving.next();
  }

  pulse() {
    this.pulseState = "pulsing";
    setTimeout(() => {
      this.pulseState = "void";
    }, 2000);
  }

  drop(event: CdkDragDrop<string[]>) {
    if (event.previousContainer === event.container) {
      // console.log("moving item", event.currentIndex)
      moveItemInArray(
        event.container.data,
        event.previousIndex,
        event.currentIndex
      );
    } else {
      // console.log("transfer", event.item.data)
      transferArrayItem(
        event.previousContainer.data,
        event.container.data,
        event.item.data,
        event.currentIndex
      );
      let array = [this.vpid1, this.vpid2, this.vpid3, this.vpid4];

      if (event.container.data.length > 1) {
        this.wordCloud.push(event.container.data.pop());
      }
    }

    this.allCorrect =
      this.vpid1[0] === this.config.demoCorrect1 &&
      this.vpid2[0] === this.config.demoCorrect2 &&
      this.vpid3[0] === this.config.demoCorrect3 &&
      this.vpid4[0] === this.config.demoCorrect4;
  }
}
